import { render, staticRenderFns } from "./JobCardInfo.vue?vue&type=template&id=b601a054&scoped=true&"
import script from "./JobCardInfo.vue?vue&type=script&lang=ts&"
export * from "./JobCardInfo.vue?vue&type=script&lang=ts&"
import style0 from "./JobCardInfo.vue?vue&type=style&index=0&id=b601a054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b601a054",
  null
  
)

component.options.__file = "JobCardInfo.vue"
export default component.exports